/* eslint-disable no-console */
import ServiceBase from './serviceBase';
import {
  FlowContainer,
  FlowCreate,
  FlowFeedbackProvided,
  FlowNextReview,
  OperFlowService,
  FlowFeedbackForSave,
  InviteReviewers,
  FlowRestart,
  FlowRelate,
  FlowReviewerDelete,
  FlowEsapInfo,
  FlowSprMission,
  FlowSprDoc,
} from './types/Flow';

const NOT_IMPLEMENTED_ERROR_MESSAGE = 'Not Implemented';

class OperEsmrService extends ServiceBase implements OperFlowService {
  create = async (data: FlowCreate): Promise<number> =>
    this.post<number>('operationesmr/create', data);

  getFlow = async (operationId: number): Promise<FlowContainer> =>
    this.get<FlowContainer>(`operationesmr/${operationId}`);

  sendForNextReview = async (data: FlowNextReview): Promise<void> =>
    this.post<void>('operationesmr/next', data);

  provideFeedback = async (data: FlowFeedbackProvided): Promise<void> =>
    this.post<void>('operationesmr/feedback', data);

  saveFeedback = async (data: FlowFeedbackForSave): Promise<void> =>
    this.post<void>('operationesmr/savefeedback', data);

  applyComplianceChanges = async (flowId: number): Promise<void> =>
    this.post<void>(`operationesmr/${flowId}/applycompliance`);

  discardComplianceChanges = async (flowId: number): Promise<void> =>
    this.post<void>(`operationesmr/${flowId}/discardcompliance`);

  openWord = async (flowId: number): Promise<string> =>
    this.post<string>(`operationesmr/${flowId}/wordlink`);

  downloadDocVersion = async (id: number): Promise<boolean> => {
    await this.download(`operationesmr/version/${id}`);
    return true;
  };

  upload = async (formData: FormData): Promise<boolean> => {
    const result = await this.post<boolean>('operationesmr/upload', formData);
    return result;
  };

  restart = async (data: FlowRestart): Promise<void> =>
    this.post<void>('operationesmr/restart', data);

  relate = async (data: FlowRelate): Promise<void> => this.post<void>('operationesmr/relate', data);

  inviteReviewers = async (data: InviteReviewers): Promise<void> =>
    this.post<void>('operationesmr/invite-reviewers', data);

  applyActionPlanChanges = async (flowId: number): Promise<void> => {
    console.log(flowId);
    throw new Error(NOT_IMPLEMENTED_ERROR_MESSAGE);
  };

  discardActionPlanChanges = async (flowId: number): Promise<void> => {
    console.log(flowId);
    throw new Error(NOT_IMPLEMENTED_ERROR_MESSAGE);
  };

  applyIndicatorsChanges = async (flowId: number): Promise<void> => {
    console.log(flowId);
    throw new Error(NOT_IMPLEMENTED_ERROR_MESSAGE);
  };

  discardIndicatorsChanges = async (flowId: number): Promise<void> => {
    console.log(flowId);
    throw new Error(NOT_IMPLEMENTED_ERROR_MESSAGE);
  };

  getSPRRationale = async (flowId: number): Promise<FlowSprDoc> => {
    console.log(flowId);
    throw new Error(NOT_IMPLEMENTED_ERROR_MESSAGE);
  };

  getSPRMissions = async (operationId: number): Promise<FlowSprMission[]> => {
    console.log(operationId);
    throw new Error(NOT_IMPLEMENTED_ERROR_MESSAGE);
  };

  removeReviewers = async (data: FlowReviewerDelete): Promise<void> =>
    this.post<void>('operationesmr/remove-reviewers', data);

  checkEsap = async (flowId: number): Promise<FlowEsapInfo> => {
    console.log(flowId);
    throw new Error(NOT_IMPLEMENTED_ERROR_MESSAGE);
  };

  deleteFlow = async (flowId: number, lap?: number | undefined) => {
    console.log(flowId, lap);
    throw new Error(NOT_IMPLEMENTED_ERROR_MESSAGE);
  };
}

const operEsmrService = new OperEsmrService();

export default operEsmrService;
